<mat-card class="card-wrapper">
    <mat-card-header>
        <mat-card-title><i class="material-icons">build</i><prl-label [value]="message"></prl-label></mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <p>
            <prl-label value="label.error.page.return.text"></prl-label>&nbsp;<a href="#" (click)="backToPrevPage()">
            <prl-label value="label.error.page.previous.page"></prl-label>
        </a>
        </p>
    </mat-card-content>

    <mat-card-actions>
        <mx-button [buttonModel]="backButton"></mx-button>
    </mat-card-actions>
</mat-card>

